import { render, staticRenderFns } from "./enter-lecture-auth-code-dialog.vue?vue&type=template&id=03b5cc23&scoped=true"
import script from "./enter-lecture-auth-code-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./enter-lecture-auth-code-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./enter-lecture-auth-code-dialog.vue?vue&type=style&index=0&id=03b5cc23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b5cc23",
  null
  
)

export default component.exports